<template>
  <div class="qr-container" v-if="value">
    <qrcode-vue :value="value" :size="size" level="M" />
    <p class="qr-label" v-if="label">{{ label }}</p>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'QrCodeDisplay',
  components: { QrcodeVue },
  props: {
    value: { type: String, required: true },
    size: { type: Number, default: 200 },
    label: { type: String, default: '' }
  }
}
</script>

<style scoped>
.qr-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--spacing-base);
  background: var(--color-bg-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
}
.qr-label {
  margin-top: var(--spacing-md);
  color: var(--color-text-secondary);
  font-size: var(--text-sm);
  font-weight: 600;
}
</style>
